import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import DonationPage from './donationPage/DonationPage';
import DonationSuccessPage from './donationPage/DonationSuccessPage';
import {
  RecurringDonationPageIndex,
  RecurringDonationPageListen,
  RecurringDonationPageListenEpisode,
  RecurringDonationPageFeedback,
  RecurringDonationPageReceipts,
} from './subscriptionsPage/RecurringDonationPage';
import {
  SubscriptionsPageIndex,
  SubscriptionsPageReceipts,
  SubscriptionsPageRecurringDonations,
} from './subscriptionsPage/SubscriptionsPage';

const Root = () => {
  return (
    <Router>
      <Routes>
        <Route path="/jar/:slug/success" element={<DonationSuccessPage />} />
        <Route path="/jar/:slug" element={<DonationPage />} />
        <Route path="/subscriptions">
          <Route index element={<SubscriptionsPageIndex />} />
          <Route path="receipts" element={<SubscriptionsPageReceipts />} />
          <Route path="recurring_tips">
            <Route index element={<SubscriptionsPageRecurringDonations />} />
            <Route path=":id">
              <Route index element={<RecurringDonationPageIndex />} />
              <Route path="listen">
                <Route index element={<RecurringDonationPageListen />} />
                <Route
                  path=":episodeId"
                  element={<RecurringDonationPageListenEpisode />}
                />
              </Route>
              <Route
                path="feedback"
                element={<RecurringDonationPageFeedback />}
              />
              <Route
                path="receipts"
                element={<RecurringDonationPageReceipts />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

Root.selector = '.page-placeholder';
Root.propExtraction = {};

export default Root;
